import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=26eb65ec&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=26eb65ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26eb65ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26eb65ec')) {
      api.createRecord('26eb65ec', component.options)
    } else {
      api.reload('26eb65ec', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=26eb65ec&scoped=true&", function () {
      api.rerender('26eb65ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sh5mi9b4R3kc/JS/comp/CookieBox.vue"
export default component.exports